module.exports = "<h3>{{ 'modules.user.login.welcome-to' | translate}} {{ 'product-name' | translate}}</h3>\r\n<psm-login-form (loginDone)=\"onLoginDone($event)\"></psm-login-form>\r\n<a [routerLink]=\"['/user/forgotPassword']\"><small>{{'modules.user.login.forgot-password' | translate}}</small></a>\r\n<p class=\"text-muted text-center\"><small>{{'modules.user.login.do-not-have-an-account' | translate}}</small></p>\r\n<a [routerLink]=\"['/user/createAccount']\" class=\"btn btn-sm btn-white btn-block\">{{'actions.create-account' | translate}}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/user/login.component.html
// module id = ./src/app/views/user/login.component.html
// module chunks = main